import { ApolloError, useMutation, useApolloClient } from '@apollo/client';

import {
  LoyaltyStateEnum,
  RegisterCustomerForLoyaltyProgramMutation,
  RegisterCustomerForLoyaltyProgramMutationVariables,
} from '@notino/shared/definitions/types';

import registerCustomerForLoyaltyProgram from '../queries/registerCustomerForLoyaltyProgram.graphql';

import { useLoyaltyPolling } from './useLoyaltyPolling';

interface UseLoyaltyStateMutationArgs {
  onError: (error: ApolloError) => void;
  onCompleted: (data: LoyaltyStateEnum) => void;
}

export const useLoyaltyStateMutation = ({
  onError,
  onCompleted,
}: UseLoyaltyStateMutationArgs) => {
  const client = useApolloClient();

  const { startPolling } = useLoyaltyPolling({
    client,
    onCompleted,
  });

  return useMutation<
    RegisterCustomerForLoyaltyProgramMutation,
    RegisterCustomerForLoyaltyProgramMutationVariables
  >(registerCustomerForLoyaltyProgram, {
    onError,
    onCompleted: () => {
      startPolling();
    },
  });
};
